import { ReferenceImageTriggerProps } from 'screens/Schedule/PostPromptsSection/Types'
import { ModalTrigger } from 'almanac-ui/Modal/ModalTrigger'
import { ImageMenuModal } from 'components/ImageMenu/ImageMenuModal/ImageMenuModal'
import { ACCEPTED_IMAGE_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import { ImageMenuSelectedImage } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'

export const ReferenceImageTrigger = ({ onUse, children, ...props }: ReferenceImageTriggerProps) => {
  return (
    <ModalTrigger
      modal={ImageMenuModal}
      uploadMedia
      title="Change Reference Image"
      accept={ACCEPTED_IMAGE_MIME_TYPES}
      maxCount={1}
      showSearchBar
      hiddenProviders={['gifs', 'blazeRecommendations']}
      onUse={(images: ImageMenuSelectedImage[]) =>
        onUse({
          id: images[0].id as string,
          key: images[0].id as string,
          source_url: images[0].source_url || '',
          url: images[0].url,
        })
      }
      {...props}
    >
      {children}
    </ModalTrigger>
  )
}
